<div style="margin-left: 5%; margin-right: 5%; padding-left: 20px;
  padding-right: 20px; background-color: #ffffff">
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <table style="width: 100%;">
          <tr>
              <td style="width: 80%;">
                    <mat-form-field style="margin-top: 0px; margin-bottom: -10px; width: 95%;">
                        <input matInput placeholder={{lblTitBusqueda}} [(ngModel)]=txtBusc
                        (keydown.enter)="buscarTxt()">
                    </mat-form-field>
              </td>
              <td style="width: 20%;">
                <i class="fas fa-search" style="width: 10px; margin-right: 20px;
                    font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                    margin-top: 0px; margin-right: 20px;" (click)="buscarTxt()">
                </i>
              </td>
          </tr>
      </table>
    </div>

    <div *ngIf="codBusqueda=='CONSORCIO'" [hidden]="escondeTabla">
        <table mat-table [dataSource]="dataSourceDATOS" style="width: 100%;">
      
          <ng-container matColumnDef="nombre" style="width: 100%;">
            <th mat-header-cell *matHeaderCellDef
              style="width: 100%;"> Nombre </th>
            <td mat-cell *matCellDef="let element"> {{element.nombre}}</td>
          </ng-container>
      
          <tr mat-header-row *matHeaderRowDef="displayedColumnsCONSORCIO"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsCONSORCIO;"
          (click)="seleccionarFila(row)"
          style="cursor: pointer;"></tr>
        </table>
    </div>

    <div *ngIf="codBusqueda=='MAIL'" [hidden]="escondeTabla">
      <table mat-table [dataSource]="dataSourceDATOS" style="width: 100%;">
    
        <ng-container matColumnDef="nombre" style="width: 100%;">
          <th mat-header-cell *matHeaderCellDef
            style="width: 100%;"> Nombre </th>
          <td mat-cell *matCellDef="let element"> {{element.nombre}}</td>
        </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="displayedColumnsMAIL"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsMAIL;"
        (click)="seleccionarFila(row)"
        style="cursor: pointer;"></tr>
      </table>
  </div>

    <div [hidden]="escondeTabla">
        <mat-paginator #paginador [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
</div>
  
<div style="margin-left: 5%; margin-right: 5%; padding: 10px; background-color: #ffffff;
    text-align: center;"
    [hidden]="!escondeTabla">
    <h4 style="color: #a31611;">No se encontraron elementos con el criterio de búsqueda</h4>
</div>
  
<div style="text-align: center; margin-top: 20px;">
    <table style="width: 100%;">
        <tr>
            <td style="width: 30%;"></td>
            <td style="width: 30%;">
                <button mat-raised-button  mat-dialog-close class="btn-agregar">
                    <i class="fas fa-window-close fa-1x" style="width: 20px; margin-right:10px;
                        font-size: 1.5em; cursor: pointer;"
                        ></i>
                    Cerrar
                </button>
            </td>
            <td style="width: 30%;"></td>
        </tr>
    </table>
</div>